import React, { Component, Fragment } from 'react'
import DashboardLayout from '../components/Admin/DashboardLayout'
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import AdminApi from '../api/admin-api/admin-api'

class UpdatePoints extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pointsList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      viewdata: '',
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Carrier',
            field: 'carrier',
            sort: 'asc',
            width: 250,
          },
          {
            label: 'Coverage',
            field: 'coverage',
            sort: 'asc',
            width: 250,
          },
          {
            label: 'Factor 1',
            field: 'factor1',
            sort: 'asc',
            width: 100,
          },
          {
            label: 'Factor 2',
            field: 'factor2',
            sort: 'asc',
            width: 100,
          },
          {
            label: 'Set Points',
            field: 'setpoints',
            sort: 'asc',
            width: 100,
          },
          {
            label: 'Update',
            field: 'update',
            sort: 'asc',
            width: 80,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'asc',
            width: 80,
          },
        ],
        rows: [
          {
            carrier: 'Aetna Senior',
            coverage: 'Medicare Supplements',
            factor1: '0.03',
            factor2: '18',
            setpoints: '0',
            update: <MDBIcon icon='edit' size='2x' className='d-flex justify-content-center blue-text' />,
            delete: <MDBIcon icon='trash' size='2x' className='d-flex justify-content-center red-text' />,
          },
          {
            carrier: 'Aliera Healthcare',
            coverage: 'Dental/Vision',
            factor1: '0.03',
            factor2: '12',
            setpoints: '0',
            update: <MDBIcon icon='edit' size='2x' className='d-flex justify-content-center blue-text' />,
            delete: <MDBIcon icon='trash' size='2x' className='d-flex justify-content-center red-text' />,
          },
          {
            carrier: 'Brokers Alliance',
            coverage: 'Life Insurance',
            factor1: '0.10',
            factor2: '9',
            setpoints: '0',
            update: <MDBIcon icon='edit' size='2x' className='d-flex justify-content-center blue-text' />,
            delete: <MDBIcon icon='trash' size='2x' className='d-flex justify-content-center red-text' />,
          },
        ],
      },
    } // state
  }

  componentDidMount() {
    this.fetchPointsData()
  }

  //convert date from sec to current date
  toDateTime = secs => {
    let t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeletePoint = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { pointsList } = this.state
    if (pointsList && pointsList.length) {
      let rows = pointsList.map(row => {
        const { carrier_name, coverage_name, factor1, factor2, setpoints, id } = row
        const self = this

        function editPoint() {
          self.props.history.push(`/add-points/${id}/edit`)
        }

        function deletePoint() {
          self.confirm_DeletePoint({ viewdata: row })
        }

        const editClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={editPoint}>
              <MDBIcon icon='edit' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deletePoint}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        return {
          carrier: carrier_name,
          coverage: coverage_name,
          factor1: factor1,
          factor2: factor2,
          setpoints: setpoints ? setpoints : '0',
          update: editClick,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  //Fetch data
  fetchPointsData = async () => {
    this.setState({ loading: true })

    try {
      const result = await AdminApi.getPointsList()
      const points = result.data.data || []

      this.setState({ pointsList: points, loading: false }, () => {
        this.setRows()
      })
    } catch (error) {
      this.setState({ loading: false })
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
    }
  }

  //Delete data
  _DeletePoint = async id => {
    this.setState({ deleting: true })
    const data = { type: 'points', id: id }

    AdminApi.deletePoint(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Point successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchPointsData()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { data, confirmModal, loading } = this.state

    const createNew = () => {
      this.props.history.push('/add-points')
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Update Points
                <div className='d-inline-block'>
                  <MDBBtn
                    type='button'
                    color='default'
                    tag='a'
                    floating
                    gradient='blue'
                    title={'Add New Point'}
                    onClick={createNew}
                  >
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              <hr />
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <div className='content-wrapper'>
                  <MDB4Datatable data={data} striped bordered small className='text-capitalize' />
                </div>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Point</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this Point?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeletePoint(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default UpdatePoints
